

import Vue from "vue";

import msgCodes from "@/extendedFunctions/msgCodes";
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
import * as action from "@/store/actions";
import { Corp, Extension } from "@/types/conf";
import store from "@/store/index";
import axios from "axios";
export default Vue.extend({
  name: "RestrictionsExtenDetail",
  props: ["resToUpdate", "exten", "isToEdit", "isToNew"],
  data: () => ({
    dialog: false,

    alertType: "",
    alertMessage: "",
    valid: false,
    showPass: false,

    newRes: {
      pattern: "",
      corpId: 0,
      description: "",
      allCorps: false,
    },

    patternList: [],

    corpList: [] as Corp[],
    extenList: [] as Extension[],
    rules: {
      required: (v: any) => v !== null && v !== undefined && v !== '' || i18n.t("loginView.required"),
      onlyNumsAndT: (v: string) => /^[0-9T]+$/.test(v) || i18n.t("rules.onlyNumbersAndT"),
      endsInNumOrT: (v: string) => /^[0-9]+T?$/.test(v) || i18n.t("rules.endsInNumOrT"),
    },
  }),
  methods: {
    ...mapActions({
      getCorpList: "crudService/getList",
      getDestinationGroup: "crudService/getList",
      newRestrictionExten: "crudService/newObject",
      updateRestrictionExten: "crudService/updateObject",
    }),

    resDetailHandler(res) {
      this.newRes.pattern = res.pattern;
      this.newRes.description = res.description || "";
      const matchingCorp = this.corpList.find(corp => corp.name === res.corpId);
      this.newRes.corpId = matchingCorp ? matchingCorp.id : null;
    },
    async validate() {
      const isValid = await this.$refs.form.validate();
      const token = localStorage.getItem("token");
      if (isValid) {
        var newRes = {
          Id: this.isToNew ? 0 : this.resToUpdate.id,
          CorpId: this.newRes.corpId,
          Pattern: this.newRes.pattern,
          Description: this.newRes.description,
        };
        let response;
        if (this.isToNew){ 
          response = await axios.post(action.RESTRICTION_CORPIN_CONTROLLER, newRes, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        } else {
          response = await axios.put(action.RESTRICTION_CORPIN_CONTROLLER, newRes, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        }

        this.dialog = response.data.id >= 400;
        this.alertMessage = msgCodes(response.data.id, this.isToNew).alertMessage;
        this.alertType = msgCodes(response.data.id, this.isToNew).alertType;
        this.$store.dispatch("snackbar/showSnack", {
          message: this.alertMessage,
          color: this.alertType,
          timeout: 3000,
        });

        this.$emit("refreshList", this.dialog)
      }
    },
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch("lookAndFeel/setCorpName");
    const corpName = store.state.lookAndFeel.corpName as string;
    if (!!to.params.exten) {
      next();
    } else {
      next({
        name: "extension",
        params: { corp: corpName, lang: navigator.language.slice(0, 2) },
      });
    }
  },

  async mounted() {
    this.corpList = await this.getCorpList(action.CORP_CONTROLLER);
    this.corpList.push({
      id: 0,
      name: this.$i18n.t("misc.allCorps"),
    });
    if (!this.isToNew) {
      this.resDetailHandler(this.resToUpdate);
    }
  },
});
